interface Props {
  className?: string;
}

export const DiscussionIcon = ({ className }: Props) => (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M27.6421 10.2134H23.6421V6.21338C23.6421 5.68295 23.4314 5.17424 23.0563 4.79917C22.6812 4.42409 22.1725 4.21338 21.6421 4.21338H5.64209C5.11166 4.21338 4.60295 4.42409 4.22788 4.79917C3.8528 5.17424 3.64209 5.68295 3.64209 6.21338V22.2134C3.64268 22.4015 3.69632 22.5857 3.79687 22.7447C3.89741 22.9037 4.04077 23.0311 4.21048 23.1123C4.38019 23.1935 4.56937 23.2252 4.75627 23.2037C4.94317 23.1822 5.12023 23.1085 5.26709 22.9909L9.64209 19.4634V23.2134C9.64209 23.7438 9.8528 24.2525 10.2279 24.6276C10.6029 25.0027 11.1117 25.2134 11.6421 25.2134H23.3408L28.0171 28.9909C28.194 29.134 28.4145 29.2125 28.6421 29.2134C28.9073 29.2134 29.1617 29.108 29.3492 28.9205C29.5367 28.733 29.6421 28.4786 29.6421 28.2134V12.2134C29.6421 11.6829 29.4314 11.1742 29.0563 10.7992C28.6812 10.4241 28.1725 10.2134 27.6421 10.2134ZM8.96084 17.4359L5.64209 20.1196V6.21338H21.6421V17.2134H9.58959C9.36072 17.2134 9.13879 17.2919 8.96084 17.4359ZM27.6421 26.1196L24.3233 23.4359C24.1464 23.2928 23.9259 23.2143 23.6983 23.2134H11.6421V19.2134H21.6421C22.1725 19.2134 22.6812 19.0027 23.0563 18.6276C23.4314 18.2525 23.6421 17.7438 23.6421 17.2134V12.2134H27.6421V26.1196Z"
      fill="currentColor"
    />
  </svg>
);
